import { render, staticRenderFns } from "./header.back.button.vue?vue&type=template&id=60bd9da8&"
import script from "./header.back.button.vue?vue&type=script&lang=js&"
export * from "./header.back.button.vue?vue&type=script&lang=js&"
import style0 from "./header.back.button.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports